/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 10.7,
    height: 18,
    viewBox: '0 0 10.7 18',
    data: '<path pid="0" _fill="none" d="M7.3 9L0 16.2 1.7 18l9-9-9-9L0 1.7z"/>'
  }
})
